import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-footer-new',
    templateUrl: './footer-new.component.html',
    styleUrls: ['./footer-new.component.scss'],
    standalone: false
})
export class FooterNewComponent implements OnInit {

  year:any
  public currentRoute: string = '';
constructor(
  private router: Router,
  private destroyRef: DestroyRef
){

}
ngOnInit():void{
  this.year = new Date().getFullYear();
  this.currentRoute = this.normalizeRoute(this.router.url);
  this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    takeUntilDestroyed(this.destroyRef)
  ).subscribe((event) => {
    this.currentRoute = this.normalizeRoute(event.urlAfterRedirects);
  });
}

/**
 * @param url Raw router URL that may contain a query string and/or fragment.
 * @returns The URL path with any query string and fragment stripped.
 */
private normalizeRoute(url: string): string {
  return url.split(/[?#]/)[0];
}

}
